<template>
  <div class="select-dealer__input">
    <input class="form-control form-control__text select-dealer__search-input" type="text" name="location"
           autocomplete="off" :placeholder="placeholder" v-model="postcode" :id="fullFormIdentifier"
           :ref="fullFormIdentifier"
           :class="{ 'no-label': !showLabel, 'no-geolocation': !locationAllowed, 'using-location': geoLocation, active: postcode !== '' }">
<!--    <button class="select-dealer__search-icon"></button>-->
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: {
    placeholder: {
      type: String,
      default: 'Postcode',
    },
    inputNullable: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    formIdentifier: {
      type: String,
      default: 'form',
    },
  },
  data() {
    return {
      locationAllowed: true,
      postcode: '',
      googleClass: false,
      autocomplete: false,
    }
  },
  computed: {
    ...mapGetters({
      geoLocation: 'Dealers/geoLocation',
    }),
    validationStar() {
      if (this.inputNullable) {
        return '';
      }
      return ' *';
    },
    fullFormIdentifier() {
      return this.formIdentifier + '-' + this._uid;
    },
  },
  methods: {
    lookupLocation() {
      navigator.geolocation.getCurrentPosition((position) => {
            this.$store.commit('Dealers/setLocation', {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });

            this.$store.dispatch('Dealers/setDistances')
                .then(() => {
                  this.$emit('changed', false);
                });
          },
          (error) => {
            this.locationAllowed = false;
          });
    }
  },
  mounted() {
    let input = this.$refs[this.fullFormIdentifier];
    GoogleMapsLoader.getMap().then(googleClass => {
      // Sometimes Google maps finishes loading after the element has already been destroyed
      if (!this.$refs[this.fullFormIdentifier]) {
        return;
      }
      this.googleClass = googleClass;
      this.autocomplete = new googleClass.maps.places.Autocomplete(input);
      this.autocomplete.setComponentRestrictions({'country': ['gb']});
      this.autocomplete.setFields(['formatted_address', 'geometry', 'place_id']);
      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete.getPlace();
        this.$store.commit('Dealers/setLocation', {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        });
        this.$store.dispatch('Dealers/setDistances')
            .then(() => {
              this.$emit('place-updated', place)
              this.$emit('postcodeSearch', true)
              this.$emit('changed', false);
            });
      });
    })
  },
  beforeDestroy() {
    if (this.autocomplete && this.googleClass && this.$refs[this.fullFormIdentifier]) {
      this.googleClass.maps.event.clearInstanceListeners(this.$refs[this.fullFormIdentifier]);
      this.autocomplete.unbindAll();
    }
  },
}
</script>

<style scoped>
@media (max-width: 767px) {
  .form-inline .location-lookup .form-control {
    display: inline-block;
    max-width: calc(100% - 42px);
  }
}

.pac-container {
  z-index: 20000;
}
</style>
